import styled from 'styled-components';
// @ts-ignore @types/constellation is not complete - need to migrate to v10 for full type support
import { Slider, SliderLabel, SliderThumb, SliderTrack } from '@zillow/constellation';
import { Box, Heading, Paragraph } from '@zillow/constellation-10';
import { printHidden, printOnly } from '../../../../styles/panda-styles';

export const StyledSlider = styled(Slider)`
  ${SliderTrack} {
    cursor: auto;
    height: 10px;
  }
  ${SliderThumb} {
    cursor: auto;
    top: 3px;
  }
  ${SliderLabel} {
    display: inline-flex;
  }
`;

export function CreditScoreBar({ creditScore }: { creditScore: number }) {
  return (
    <>
      <Box css={printHidden}>
        <Box css={{ marginTop: 'xl', paddingTop: 'xs' }}>
          <StyledSlider
            id="credit-score-slider"
            min={300}
            max={850}
            value={creditScore}
            // @ts-ignore @types/constellation is not complete - need to migrate to v10 for full type support
            disabled
          />
        </Box>
        <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
          <Paragraph textStyle="body-sm" color="textMedium">
            300
          </Paragraph>
          <Paragraph textStyle="body-sm" color="textMedium">
            850
          </Paragraph>
        </Box>
      </Box>
      <Box css={printOnly}>
        <Heading level={3} css={{ marginTop: 'sm', marginBottom: 'sm' }}>
          {creditScore}
        </Heading>
      </Box>
    </>
  );
}
